export const detailsQueryKeys = {
  all: () => ['details'],
};
